// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b29c4d22","502":"03040606","583":"d70db96b","788":"ac7001f0","859":"c1a72d61"}[chunkId] + ".chunk.js";
};